import * as React from 'react';
import RDatePicker, { ReactDatePickerProps, registerLocale, setDefaultLocale } from 'react-datepicker';
import './DatePicker.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { format, parse } from 'date-fns';
import { DateFormat, formatDate, newIsoDate, parseDate, ro } from '../../lib/date';
import { noop } from 'lodash';

registerLocale('ro', ro);
setDefaultLocale('ro');

class DatePicker extends React.Component<DatePicker.IProps & Omit<ReactDatePickerProps, 'onChange'>, DatePicker.IState> {
  static defaultProps: DatePicker.IProps = { onChange: noop, formatDate: DateFormat, withMount: false };

  _getDateFormat = () => {
    return this.props.formatDate || DateFormat;
  };

  componentDidMount() {
    const value = parse(this._getValue(), this._getDateFormat(), newIsoDate());

    if (this.props.withMount && value instanceof Date) {
      this._onChange(value, { currentTarget: {}, preventDefault: () => undefined, persist: () => undefined } as any);
    }
  }

  _getValue = () => {
    const { minDate, value } = this.props;
    let date = parseDate(value);

    if (minDate && date < minDate) {
      date = new Date(minDate);
    }

    return format(date, this._getDateFormat());
  };

  _onChange: ReactDatePickerProps['onChange'] = (date: Date, event) => {
    if (event && event.currentTarget) {
      event.currentTarget.id = this.props.id;
      event.currentTarget.value = format(date, this._getDateFormat());
    }

    return this.props.onChange(event);
  };

  render() {
    const { onChange, value: v, ...rest } = this.props;

    const value = this._getValue();
    const dateFormat = this._getDateFormat();

    return (
      <RDatePicker
        wrapperClassName="eon-datepicker"
        popperClassName="eon-datepicker"
        dateFormat={this._getDateFormat()}
        showMonthYearPicker
        onChange={this._onChange}
        onKeyDown={event => event.preventDefault()}
        selected={value ? parse(value, dateFormat, new Date()) : undefined}
        customInput={<DatePickerInput />}
        value={value}
        {...rest}
      />
    );
  }
}

const DatePickerInput = React.forwardRef((props: any, ref) => {
  const { value, ...rest } = props;
  const formatValue = formatDate(value);

  return <input {...rest} value={formatValue} ref={ref} />;
});

export default DatePicker;
